import React, { FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import CustomModal from "../../common/custom-modal/custom-modal";
import { Colors } from "../../../configs";
import { CustomButton } from "../../atoms";
import { pxToRem } from "../../../util";
import UpdateCardsModal from "../../../components/pos/update-cards-modal/UpdateCardsModal";
import Payment from "../payment-modal/payment";
import { PaymentTypeEnum } from "../../../typings/enum/paymentTypes";

type PaymentModalData = { paymentMode: PaymentTypeEnum; paidAmount: number };

interface AddCardWarningModalProps {
  open: boolean;
  onClose(): void;
  onAddCard?(): void;
}

const AddCardWarningModal: FC<AddCardWarningModalProps> = ({
  open,
  onClose,
  onAddCard,
}) => {
  const [isUpdateCardsModalOpen, setIsUpdateCardsModalOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  // No default - the cashier must actively pick a payment method every time.
  const [paymentType, setPaymentType] = useState<PaymentTypeEnum | null>(null);

  useEffect(() => {
    if (isPaymentOpen) setPaymentType(null);
  }, [isPaymentOpen]);

  const handleAddCard = () => {
    onAddCard?.();
    setIsUpdateCardsModalOpen(true);
    onClose();
  };

  const handlePaymentCheckout = (data: PaymentModalData | null) => {
    setIsPaymentOpen(false);
  };

  return (
    <>
      <CustomModal
        title="Warning!"
        openModal={open}
        width={pxToRem(650)}
        height={pxToRem(440)}
        onClose={onClose}
        titleColor={Colors.ERROR_RED}
      >
        <Box
          sx={{ position: "relative", height: "100%", width: "100%", pb: 1.5 }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
              p: "2rem 1.5rem",
            }}
          >
            <Typography
              sx={{
                color: Colors.TEXT_GRAY_DARK,
                fontSize: pxToRem(24),
                lineHeight: 1.5,
                mb: "auto",
                textAlign: "left",
                pt: 1,
              }}
            >
              You must add a card before proceeding with Box Storage.
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                pt: "2rem",
              }}
            >
              <CustomButton
                sx={{
                  height: pxToRem(60),
                  width: "100%",
                  fontSize: pxToRem(24),
                  fontWeight: "500",
                  backgroundColor: Colors.PRIMARY,
                  color: Colors.WHITE,
                  borderRadius: pxToRem(8),
                  mb: 0.8,
                  "&:hover": { backgroundColor: Colors.REPORT_DARK_GREEN },
                }}
                onClick={handleAddCard}
              >
                Add Card
              </CustomButton>
            </Box>
          </Box>
        </Box>
      </CustomModal>

      <UpdateCardsModal
        open={isUpdateCardsModalOpen}
        onClose={() => setIsUpdateCardsModalOpen(false)}
        openPaymentOnAddNew
        onOpenPaymentModal={() => {
          setIsUpdateCardsModalOpen(false);
          setIsPaymentOpen(true);
        }}
      />

      <CustomModal
        title="Payment"
        openModal={isPaymentOpen}
        onClose={() => setIsPaymentOpen(false)}
        width="95.0714286rem"
        height="64.7857143rem"
      >
        <Payment
          onCheckout={handlePaymentCheckout}
          onPaymentTypeChange={(pt) => setPaymentType(pt)}
          paymentType={paymentType}
        />
      </CustomModal>
    </>
  );
};

export default AddCardWarningModal;
